import { render, staticRenderFns } from "./backoffice-operadora-convenio.vue?vue&type=template&id=14283b27"
import script from "./backoffice-operadora-convenio.vue?vue&type=script&lang=ts"
export * from "./backoffice-operadora-convenio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports